// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export enum CollisionSensitivity {
	Lowest = 0,
	Low = 1,
	Medium = 2,
	High = 3,
	Highest = 4,
}

export const CollisionSensitivityDisplayNames: { [key in keyof typeof CollisionSensitivity]?: string} = {
	"Lowest": "Lowest",
	0 : "Lowest",
	"Low": "Low",
	1 : "Low",
	"Medium": "Medium",
	2 : "Medium",
	"High": "High",
	3 : "High",
	"Highest": "Highest",
	4 : "Highest",
}

export const getCollisionSensitivityDisplayName = (key: CollisionSensitivity | (keyof typeof CollisionSensitivity & string)) => {
	return CollisionSensitivityDisplayNames[key];
}

